module.exports = __webpack_public_path__ + "static/img/an_4.2d29d03.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/an_4.png
// module id = 826
// module chunks = 1